import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "share-menu" }
const _hoisted_2 = { class: "share-menu__title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "share-menu__title-text" }, " Tell your friends ", -1)
const _hoisted_4 = { class: "share-menu__content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Tell your friends about the new way to create professional visuals for their beats.", -1)
const _hoisted_6 = { class: "share-menu__socials-list" }

import Speaker from '@/assets/Speaker.svg'
import CaretDown from '@/assets/CaretDown.svg'
import BigButton from '@/components/common/BigButton.vue'
import CopyIcon from '@/assets/CopyIcon.svg'
import FacebookIcon from '@/assets/FacebookIcon.svg'
import TwitterIcon from '@/assets/TwitterIcon.svg'
import EmailIcon from '@/assets/EmailIcon.svg'
import { useApplicationStore } from '@/store/application-store'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareMenu',
  setup(__props) {

const applicationStore = useApplicationStore()

const getVisualizerURL = () => {
  return 'https://serato.com/visualizer'
}

const getFacebookShareURL = () => {
  return `https://www.facebook.com/sharer.php?u=${getVisualizerURL()}`
}

const getTwitterShareURL = () => {
  const body = encodeURIComponent(
    'Get early access to Serato Visualizer and create custom-built, attention-grabbing videos for your music.'
  )

  return `https://twitter.com/intent/tweet?url=${getVisualizerURL()}&text=${body}`
}

const copyLink = () => {
  navigator.clipboard.writeText(getVisualizerURL()).then(
    () => {
      applicationStore.pushSnackbarMessage({
        state: 'success',
        header: 'Link copied to clipboard'
      })
    }
  )
}

const openShareDialog = (targetId: string) => {
  const url = targetId === 'facebook' ? getFacebookShareURL() : getTwitterShareURL()
  window.open(url, `${targetId}-share-dialog`, 'width=626,height=436')
}

const emailShare = () => {
  const subject = encodeURIComponent('Your invite to get your music seen with Serato Visualizer')
  const body = encodeURIComponent(`Wanting to build your artistic brand and get more heat on your beats? Serato Visualizer is designed for music producers and allows you to stand out from the crowd with custom-built videos optimized for social media. 

Grab the attention of your friends and fans with professional-level videos made from Serato’s extensive content library or with over 3 million videos, photos, GIFs, and stickers from GIPHY and Pexels. 

Serato Visualizer is free to use with no limits or watermarks, head to ${getVisualizerURL()} and get your music seen today.`
  )
  window.open(`mailto:?subject=${subject}&body=${body}`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Speaker), { class: "share-menu__icon" }),
      _hoisted_3,
      _createVNode(_unref(CaretDown), { class: "share-menu__icon share-menu__icon--hoverable share-menu__icon--lowered" })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(BigButton, {
        class: "share-menu__copy-btn",
        text: "Copy link to share",
        type: "secondary",
        "is-disabled": false,
        "is-loading": false,
        onClick: copyLink
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(CopyIcon))
        ]),
        _: 1
      }),
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openShareDialog('facebook')))
        }, [
          _createVNode(_unref(FacebookIcon), { class: "share-menu__social-icon" })
        ]),
        _createElementVNode("li", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (openShareDialog('twitter')))
        }, [
          _createVNode(_unref(TwitterIcon), { class: "share-menu__social-icon" })
        ]),
        _createElementVNode("li", { onClick: emailShare }, [
          _createVNode(_unref(EmailIcon), { class: "share-menu__social-icon" })
        ])
      ])
    ])
  ]))
}
}

})